import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-audit-trail-entry, app-audit-entry',
  templateUrl: './app-audit-trail-entry.component.html',
  styleUrls: ['./app-audit-trail-entry.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppAuditTrailEntryComponent),
      multi: true,
    },
  ],
})
export class AppAuditTrailEntryComponent implements ControlValueAccessor {
  @ViewChild('textareaRef') textareaRef?: ElementRef<HTMLTextAreaElement>;

  @Input() label: string = 'Add entry';
  @Input() placeholder: string = 'Type your note or activity update...';
  @Input() buttonText: string = 'Save note';
  @Input() value: string = '';
  @Input() rows: number = 3;
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() mandatory: boolean = false;
  @Input() optional: boolean = false;
  @Input() customClass: string = '';

  @Output() valueChange = new EventEmitter<string>();
  @Output() save = new EventEmitter<string>();
  @Output() submitEntry = new EventEmitter<string>();

  isFocused: boolean = false;

  private onChange: (val: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(val: any): void {
    this.value = val || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.value = target.value;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }

  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
  }

  onKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLTextAreaElement;
    if (event.key === ' ' && input.selectionStart === 0) {
      event.preventDefault();
      return;
    }

    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      this.onSubmit();
    }
  }

  onSubmit(): void {
    if (this.disabled || !this.value || this.value.trim().length === 0) {
      return;
    }
    const val = this.value.trim();
    this.save.emit(val);
    this.submitEntry.emit(val);
  }
}
